import axios from "../../axios";

const cancel = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.post('admin/pay-out/cancel', {}, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default cancel;
